<template>
    <div id="app" class="app-layout">
        <Header></Header>

        <!-- MAIN -->
        <div class="main" id="main">
            <Advantages></Advantages>

            <Overview></Overview>

            <Gallery></Gallery>

            <CallToAction></CallToAction>

            <Donate></Donate>

            <Contacts></Contacts>

            <Footer></Footer>
        </div>
        <!-- MAIN -->
    </div>
</template>

<script>
    import Header from '@/components/common/Header';
    import Advantages from '@/components/common/Advantages';
    import Overview from '@/components/common/Overview';
    import Gallery from '@/components/common/Gallery';
    import CallToAction from '@/components/common/CallToAction';
    import Donate from '@/components/common/Donate';
    import Contacts from '@/components/common/Contacts';
    import Footer from '@/components/common/Footer';
    import $ from 'jquery';
    import nicescroll from 'jquery.nicescroll'

    export default {
        name: 'app',
        components: {
            Header,
            Advantages,
            Overview,
            Gallery,
            CallToAction,
            Donate,
            Contacts,
            Footer
        },
        data() {
            return {};
        },
        created() {
            $('html').niceScroll({
                cursorcolor: '#777',
                cursoropacitymax: 0.7,
                cursorwidth: '9',
                cursorborder: 'none',
                cursorborderradius: '10px',
                background: '#ccc',
                zindex: '9999999',
                touchbehavior: false,
//                horizrailenabled: false,
                scrollspeed: '120',
            });
        },
        methods: {
            updateAnimations() {
                window.addEventListener("scroll", function () {
                    var $elems = $('.animateblock'),
                        windowHeight = $(window).height(),
                        fullHeight = $(document).height(),
                        windowTop = $(window).scrollTop(); // calculate distance from top of window

                    // loop through each item to check when it animates
                    $elems.each(function () {
                        var $elm = $(this);

                        if ($elm.hasClass('animated')) {
                            return true;
                        } // if already animated skip to the next item

                        var topCoords = $elm.offset().top; // element's distance from top of page in pixels

                        function getWidth() {
                            return window.innerWidth / 14;  // for responsive circles
                        }

                        if (windowTop > (topCoords - (windowHeight * 0.7))) {
                            // animate when top of the window is 3/4 above the element
                            $elm.addClass('animated');
                        }
                    });
                })

                $('.parallax').each(function () {
                    var $obj = $(this),
                        yPos = (($(window).scrollTop() / $obj.data('speed')) / 2),
                        bgPos = yPos + 'px';
                    $obj.css('top', bgPos);
                });
            }
        },
        mounted() {
            this.updateAnimations();
        }
    };
</script>



// WEBPACK FOOTER //
// App.vue?26d52816